import React, { useContext } from 'react'
import { DemoContext } from '../lib/DemoProvider'
import Home from './Home'
import Nav from './Nav'
import IntroApi from './IntroGetStarted'
import IntroStandalone from './IntroStandalone'
import IntegrationHtml from './IntegrationHtml'
import IntegrationNpm from './IntegrationNpm'
import DemoHtml from './DemoHtml'
import DemoApp from './DemoApp'
import analytics from '../config/analytics'

export default function Main () {
    const { page } = useContext(DemoContext)
    analytics.sendPageName(page)
    return (
        <React.Fragment>
            {page === 'home' && <div className="adobe-app"><Nav /><Home /></div>}
            {page === 'removebackgroundapi' && <div className="adobe-app"><Nav /><IntroApi /></div>}
            {page === 'standalone' && <div className="adobe-app"><Nav /><IntroStandalone /></div>}
            {page === 'integrationhtml' && <div className="adobe-app"><Nav /><IntegrationHtml /></div>}
            {page === 'integrationnpm' && <div className="adobe-app"><Nav /><IntegrationNpm /></div>}
            {page === 'demohtml' && <div className="adobe-app"><Nav /><DemoHtml /></div>}
            {page === 'demoapp' && <div className="adobe-app"><Nav /><DemoApp /></div>}
        </React.Fragment>
    )
}
